import { asText } from "@prismicio/helpers";
import { useState, useMemo } from "react";
import WvPhotoCarouselPreview from "~/components/molecules/WvPhotoCarouselPreview";
import WvPhotoCarouselSwiper from "~/components/organisms/WvPhotoCarouselSwiper";
import type { PhotoCarouselWithRichTextSliceDefault } from "prismicio-types";
import type { HTMLComponent } from "@commercekit/react";
import { wrapIframe } from "@commercekit/shared";

const DefaultPhotoCarouselWithRichText: HTMLComponent<{
  slice: PhotoCarouselWithRichTextSliceDefault;
}> = ({ slice }) => {
  const [showPreview, setShowPreview] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const images = slice.items.map((item) => item.image);
  const content = useMemo(() => {
    return wrapIframe(asText(slice.primary.content));
  }, [slice.primary.content]);
  return (
    <>
      <div className="col-12 px-0">
        <div className="container">
          <div className="row">
            <div className="col-12">
              {slice.primary.title && slice.primary.title.length > 0 && (
              <h1 className="heading strong xl underlined left pb-3 mb-3">
                  {asText(slice.primary.title)}
                </h1>
              )}
            </div>
            <div className="col-12 ">
              <div
                className="content"
                dangerouslySetInnerHTML={{
                  __html: content || "",
                }}
              ></div>
            </div>
          </div>
        </div>
      </div>
      <section className="component-carousel">
        <div className="container pr-lg-5">
          <div className="content">
            <h2 className="heading"> {asText(slice.primary.carousel_title)}</h2>
          </div>
          <div className="row">
            <div className="col-12 col-lg-6 ">
              <WvPhotoCarouselSwiper
                images={images}
                onPreview={(index: number) => {
                  setActiveIndex(index);
                  setShowPreview(true);
                }}
              />
            </div>
            <div className="col-12 col-lg-6 px-lg-5 component-carousel__text content d-flex flex-column justify-content-center align-items-center "></div>
          </div>
        </div>
      </section>{" "}
      {showPreview ? (
        <WvPhotoCarouselPreview
          activeIndex={activeIndex}
          onClose={() => {
            setShowPreview(false);
          }}
          images={images}
        />
      ) : null}
    </>
  );
};

export default DefaultPhotoCarouselWithRichText;
